<template>
    <div class="topic-container">
        <div class="basic-info">
            <div class="head">
                <img class="top" src="../../images/community/top.png" alt="" v-if="topicInfo.is_top">
                <span v-if="topicInfo.is_refining" class="tag featured">精选</span>
                <span v-if="topicInfo.comment_is_accept_by_topic" class="tag solved">已解决</span>
                <h3  @click="goQuestionDetail(topicInfo)" class="question-name">
                    <p v-html="filterXSS(topicInfo.afterHtmlTitle || topicInfo.title)"></p>
                </h3>
            </div>
            <ul class="tags">
                <li v-for="(i,index) in topicInfo.tags" @click="tagSelector(i)" :key="index">
                    {{i.title}}
                </li>
            </ul>
            <div class="question-content-wrapper" v-if="topicInfo.no_of_comment">
                <div style="display: none;" :id="`virtual-dom-${topicInfo.id}`" class="question-desc img-hook"  v-html="filterXSS(topicInfo.afterhtmlData)" ref="descHook"></div>
                <div class="comment-content-wrapper" @click="goDetailComment(topicInfo, index)">
                    <div class="user-content-wrapper" v-if="!topicInfo.isMatchComment">
                        <el-popover
                            popper-class="user-card"
                            placement="top"
                            :open-delay="500"
                            width="400"
                            trigger="hover"
                            @show="$refs['card' + topicInfo.comment_user.id + topIndex].getUserInfo()">
                            <div style="text-align: right; margin: 0, padding: 0">
                                <user-card :ref="`card${topicInfo.comment_user.id}${topIndex}`" :user-id="topicInfo.comment_user.id"></user-card>
                            </div>
                            <div slot="reference" class="user-avatar" @click="visible = !visible">
                                <img class="identity-icon"
                                    src="../../images/personal_center/avatar_default.png"
                                    v-if="topicInfo.comment_user.user_logo.substr(0,1)=='?'" @click.stop="goHomePage(topicInfo.comment_user)">
                                <img class="identity-icon" :src="topicInfo.comment_user.user_logo" alt="" v-else @click.stop="goHomePage(topicInfo.comment_user)">
                                <span class="text name" @click.stop="goHomePage(topicInfo.comment_user)">{{topicInfo.comment_user.nick_name}}</span>
                            </div>
                        </el-popover>
                        <el-tooltip v-if="topicInfo.comment_user.is_official" effect="light" content="蓝鲸智云官方" placement="right">
                            <svg style="width: 20px; height: 20px" aria-hidden="true">
                                <use xlink:href="#icon-lanjingguanfang"></use>
                            </svg>
                        </el-tooltip>
                        <el-tooltip v-if="topicInfo.comment_user.is_vip" effect="light" content="核心用户" placement="right">
                            <span class="icon-vipuser"></span>
                        </el-tooltip>
                        <span class="text">{{getTime(topicInfo.comment_created_on)}}回答</span>
                        <span class="tag adopted" v-if="topicInfo.comment_is_accept_by_topic">已采纳</span>
                    </div>
                    <div class="comment-specific-wrapper">
                        <p
                            v-if="!topicInfo.isMatchComment"
                            :class="['comment-left', {'active': topicInfo.is_approval}]"
                            @click.stop="onApproval(topicInfo)">
                            <span>{{topicInfo.comment_up_list.length}}</span>
                            <span class="text">{{ topicInfo.is_approval ? '已赞' : '赞同'}}</span>
                        </p>
                        <p class="comment-img" v-if="!topicInfo.isMatchComment && topicInfo.show_image.length">
                            <img :src="topicInfo.show_image[0].access_url" />
                        </p>
                        <div :class="['comment-desc', topicInfo.isAllComment ? 'pack-up' : 'ellipsis']" v-if="topicInfo.comment">
                            <span class="desc" v-html="filterXSS(topicInfo.comment)"></span>
                            <!-- 查看详情/收起 -->
                            <template v-if="topicInfo.isShowAllComment">
                                <span class="link" @click.stop="onShowAllComment(topicInfo.id)">
                                    {{ topicInfo.isAllComment ? '收起' : '查看详情'}}
                                    <i :class="`el-icon-arrow-${topicInfo.isAllComment ? 'up' : 'down'}`"></i>
                                </span>
                                <!-- 单条评论过长吸底 -->
                                <p
                                    v-if="fixedCommentId === topicInfo.id"
                                    class="fixed-bottom"
                                    :style="getCommentCollapsePos()"
                                    @click.stop="onShowAllComment(topicInfo.id)">
                                    收起
                                    <i class="el-icon-arrow-up"></i>
                                </p>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
            <div class="comment-bottom-content">
                <div class="footer-list">
                    <div class="answer-type" v-if="isSearch">问答</div>
                    <p class="footer-item answer default" :class="{'gray':!topicInfo.is_me_comment}" @click="goQuestionDetail(topicInfo, true)">
                        <i class="answer-icon"></i>
                        <span>{{topicInfo.no_of_comment}}<i class="text">回答</i></span>
                    </p>
                    <p class="footer-item view default">
                        <i class="smart-icon view-icon"></i>
                        <span>{{topicInfo.no_of_views | transformUnit}}<i class="text">阅览</i></span>
                    </p>
                    <el-tooltip
                        effect="dark"
                        :content="topicInfo.is_followed ? '取消关注' : '关注问题'"
                        placement="top">
                        <p :class="['footer-item', { 'is-active': topicInfo.is_followed }]" @click="focusToggle(topicInfo)">
                            <i class="smart-icon follow-icon"></i>
                            <span>{{topicInfo.no_of_followed}}<i class="text">关注</i></span>
                        </p>
                    </el-tooltip>
                </div>
                <p class="topic-people">
                    <el-popover
                        popper-class="user-card"
                        placement="top"
                        :open-delay="500"
                        width="400"
                        trigger="hover"
                        @show="$refs['card' + topicInfo.created_by.id].getUserInfo()">
                        <div style="text-align: right; margin: 0, padding: 0">
                            <user-card :ref="`card${topicInfo.created_by.id}`" :user-id="topicInfo.created_by.id"></user-card>
                        </div>
                        <div slot="reference" class="user-avatar" @click="visible = !visible">
                            <img class="create-user-logo"
                                src="../../images/personal_center/avatar_default.png"
                                v-if="topicInfo.created_by.user_logo.substr(0,1)=='?'" @click="goHomePage(topicInfo.created_by)">
                            <img class="create-user-logo" :src="topicInfo.created_by.user_logo" alt="" v-else @click="goHomePage(topicInfo.created_by)">
                            <span class="create-user-name" @click="goHomePage(topicInfo.created_by)" v-html="filterXSS(topicInfo.afterHtmlName)"></span>
                        </div>
                    </el-popover>
                    <el-tooltip v-if="topicInfo.created_by.is_official" effect="light" content="蓝鲸智云官方" placement="right">
                        <svg style="width: 20px; height: 20px" aria-hidden="true">
                            <use xlink:href="#icon-lanjingguanfang"></use>
                        </svg>
                    </el-tooltip>
                    <el-tooltip v-if="topicInfo.created_by.is_vip" effect="light" content="核心用户" placement="right">
                        <span class="icon-vipuser"></span>
                    </el-tooltip>
                    <span> 于 {{topicInfo.created_on}}发布</span>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
    import userCard from '../common/userCard.vue'
    import bus from '@/js/bus.js';
    export default {
        components: {
            userCard
        },
        props: {
            topIndex: {
                type: Number,
                default: 0
            },
            topicInfo: {
                type: Object,
                default: () => ({})
            },
            fixedCommentId: {
                type: String,
                default: ''
            },
            isSearch: {
                type: Boolean,
                default: false
            },
            userId: {
                type: Number,
                default: 0
            }
        },
        filters: {
            transformUnit (val) {
                if (val > 10000) {
                    let num = Math.floor( val / 1000 )
                    const remainder = val % 1000
                    if (remainder > 100) {
                        num += `.${Math.floor(remainder / 100)}`
                    }
                    return `${num}K`
                }
                return val
            }
        },
        methods: {
            getUserInfo (id) {
                console.log(this.$refs['card' + id].getUserInfo)
            },
            // 点击热门标签
            tagSelector (item) {
                this.$emit('tagSelector', item);
            },
            goQuestionDetail (item, isComment) {
                if (isComment) {
                    localStorage.setItem('commentWrapper', true)
                }
                let routeData = this.$router.resolve({
                    name: 'Question',
                    params: {
                        wid: item.id
                    },
                    query: {
                        type: 'answer'
                    }
                })
                window.open(routeData.href, '_blank')
            },
            // 跳转到详情的评论去
            goDetailComment (comment, index) {
                localStorage.setItem('commentId', comment.comment_id)
                let routeData = this.$router.resolve({
                    name: 'Question',
                    params: {
                        wid: comment.id
                    },
                    query: {
                        type: 'answer'
                    }
                })
                window.open(routeData.href, '_blank')
            },
            // 前往个人主页
            goHomePage (userInfo) {
                // 判断是否为自己或者他人
				const isMatch = this.userId === userInfo.user_id
				const path = isMatch ? '/s-mart/personal_center/' : `/s-mart/personal_center/user/${userInfo.user_id}`
                let routeData = this.$router.resolve({
                    path
                })
                window.open(routeData.href, '_blank')
            },
            // 修改发布时间格式
            getTime (stringTime) {
                let minute = 1000 * 60;
                let hour = minute * 60;
                let day = hour * 24;
                let week = day * 7;
                let month = day * 30;
                let time1 = new Date().getTime(); // 当前的时间戳
                let time2 = Date.parse(new Date(stringTime)); // 指定时间的时间戳
                let time = time1 - time2;
                let result = null;
                const date = stringTime.split(' ')[0]
                if (time / month >= 1 || time / week >= 1) {
                    result = date
                } else if (time / day >= 1) {
                    result = parseInt(time / day) + '天前';
                } else if (time / hour >= 1) {
                    result = parseInt(time / hour) + '小时前';
                } else if (time / minute >= 1) {
                    result = parseInt(time / minute) + '分钟前';
                } else {
                    result = '刚刚';
                }
                return result;
            },
            // 赞同
            onApproval (data) {
                // 校验信息是否完善
                if (!this.$store.state.informationComplete) {
                    bus.$emit('openInformationPopup')
                    return
                }
                this.$emit('onApproval', data)
            },
            onShowAllComment (id) {
                this.$emit('onShowAllComment', id)
            },
            // 获取吸底“收起”栏的位置坐标
            getCommentCollapsePos () {
                const commentEl = document.querySelector('.comment-content-wrapper')
                const commentWrapperLeft = commentEl.getBoundingClientRect().left
                return { left: `${commentWrapperLeft}px` }
            },
            // 关注&取消关注
            focusToggle (item) {
                // 校验信息是否完善
                if (!this.$store.state.informationComplete) {
                    bus.$emit('openInformationPopup')
                    return
                }
                this.$emit('focusToggle', item)
            }
        }
    }
</script>

<style lang="scss" scoped>
    .topic-container {
        .basic-info{
            .tag {
                flex-shrink: 0;
                margin-right: 7px;
                line-height: 16px;
                font-size: 12px;
                border-radius: 2px;
            }
            .head{
                display: flex;
                align-items: flex-start;
                .top {
                    width: 24px;
                    height: 24px;
                    margin-right: 7px;
                }
                .featured {
                    padding: 3px 8px;
                    color: #e28c02;
                    background: #ffe8c3;
                }
                .solved {
                    padding: 3px 7px;
                    color: #14a568;
                    background: #e4faf0;
                }
                .question-name {
                    word-break: break-all;
                    cursor: pointer;
                    font-size: 16px;
                    line-height: 21px;
                    color: #313238;
                    font-weight: bold;
                    transition: all 0.3s ease;
                    &:hover {
                        color: #3a84ff;
                    }
                }
            }
            .tags {
                margin-top: 8px;
                display: flex;
                align-items: center;
                flex-wrap: wrap;
                >li {
                    cursor: pointer;
                    margin: 0 10px 10px 0;
                    padding: 3px 11px;
                    border-radius: 12px;
                    border: 1px solid rgba(151,155,165,0.30);
                    background: #fafbfd;
                    font-size: 12px;
                    color: #63656e;
                    text-align: center;
                    line-height: 16px;
                    &:hover {
                        background: #e1ecff;
                        color: #3a84ff;
                        border: 1px solid #3a84ff;
                    }
                }
            }
            .question-content-wrapper {
                font-size: 14px;
                color: #63656e;
                cursor: pointer;
                .comment-content-wrapper {
                    padding: 8px 10px 10px 15px;
                    width: 100%;
                    background: rgba(243, 244, 245, .72);
                    border-radius: 2px;
                    .user-content-wrapper {
                        font-size: 12px;
                        display: flex;
                        align-items: center;
                        .identity-icon {
                            width:28px;
                            height:28px;
                            border-radius: 50%;
                            border:1px solid #dcdee5;
                            cursor: pointer;
                        }
                        .text {
                            color: #979ba5;
                            &.name {
                                margin: 0 2px 0 12px;
                                color: #63656e;
                            }
                        }
                        .adopted {
                            padding: 1px 4px;
                            color: #14a568;
                            border: 1px solid #14a568;
                            margin-left: 8px;
                        }
                    }
                    .comment-specific-wrapper {
                        display: flex;
                        align-items: flex-start;
                        .comment-left {
                            flex-shrink: 0;
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            font-size: 12px;
                            transform: scale(.8);
                            line-height: 12px;
                            text-align: center;
                            padding: 2px 4px;
                            background: #e6e6e7;
                            border-radius: 2px;
                            font-weight: 500;
                            margin: 0 10px 0 -2px;
                            cursor: pointer;
                            .text {
                                margin-top: 3px;
                            }
                            &.active, &:hover {
                                color: #3a84ff;
                                background: #e1ecff;
                            }
                        }
                        .comment-img {
                            margin-right: 9px;
                            img {
                                width: auto;
                                height: auto;
                                max-height: 66px;
                                max-width: 112px;
                            }
                            & + .comment-desc {
                                -webkit-line-clamp: 3 !important;
                            }
                        }
                        .comment-desc {
                            flex: 1;
                            overflow: hidden;
                            font-size: 14px;
                            line-height: 22px;
                            position: relative;
                            &.ellipsis {
                                text-overflow: ellipsis;
                                display: -webkit-box;
                                -webkit-box-orient: vertical;
                                -webkit-line-clamp: 2;
                            }
                            .link {
                                position: absolute;
                                bottom: 0;
                                right: 0;
                                background: #f6f7f8;
                                padding: 0 15px;
                                cursor: pointer;
                                color: #3a84ff;
                            }
                            &.pack-up {
                                padding-bottom: 25px;
                            }
                            .fixed-bottom {
                                position: fixed;
                                bottom: 0;
                                width: 790px;
                                height: 59px;
                                line-height: 59px;
                                text-align: center;
                                background: #fff;
                                cursor: pointer;
                                color: #3a84ff;
                            }
                        }
                    }
                }
            }
            .comment-bottom-content {
                padding-right: 6px;
                margin-top: 11px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                color: #63656e;
                .footer-list {
                    font-size: 0;
                    display: flex;
                    align-items: center;
                    .answer-type {
                        position: relative;
                        width: 34px;
                        height: 20px;
                        border: 1px solid #b6d2ff;
                        border-radius: 2px;
                        font-size: 12px;
                        color: #3a84ff;
                        text-align: center;
                        line-height: 18px;
                        margin-right: 27px;
                        &::after {
                            content: '';
                            width: 4px;
                            height: 4px;
                            opacity: 1;
                            background: #979ba5;
                            border-radius: 50%;
                            position: absolute;
                            right: -14px;
                            top: 8px;
                        }
                    }
                    .footer-item {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-size: 12px;
                        transition: all 0.3s ease;
                        &.answer {
                            width:84px;
                            line-height: 29px;
                            text-align: center;
                            margin-right: 40px;
                            color: #3a84ff;
                            background:#e1ecff;
                            border-radius:4px;
                            cursor: pointer;
                            .answer-icon {
                                height: 16px;
                                width: 16px;
                                margin-right: 5px;
                                background: url('../../images/community/comment5.png');
                                background-size: 100% 100%;
                            }
                            &:hover {
                                background: #d4e4ff;
                            }
                            &.gray {
                                color: #63656e;
                                background:#f0f1f5;
                                &:hover {
                                    background: #ececee;
                                }
                                .answer-icon {
                                    background: url('../../images/community/comment3.png');
                                    background-size: 100% 100%;
                                }
                            }
                        }
                        &.view {
                            margin-right: 40px;
                        }
                        .smart-icon {
                            height: 16px;
                            width: 16px;
                            position: relative;
                            z-index: 2;
                            margin-right: 5px;
                            &::before, &::after {
                                content: '';
                                height: 16px;
                                width: 16px;
                                position: absolute;
                                z-index: 1;
                                display: none;
                            }
                            &.view-icon {
                                background: url('../../images/community/eye-open.png');
                                background-size: 100% 100%;
                            }
                            &.follow-icon {
                                background: url('../../images/community/like3.png');
                                background-size: 100% 100%;
                                &::before {
                                    background: url('../../images/community/like4.png');
                                    background-size: 100% 100%;
                                }
                                &::after {
                                    background: url('../../images/community/like5.png');
                                    background-size: 100% 100%;
                                }
                            }
                        }
                        .text {
                            margin-left: 2px;
                            font-style: initial;
                        }
                        &:hover {
                            &:not(.default) {
                                cursor: pointer;
                                color: #3a84ff;
                            }
                            .smart-icon::before {
                                display: block;
                                z-index: 3;
                            }
                        }
                        &.is-active {
                            color: #3a84ff;
                            .smart-icon {
                                background: none;
                                &::before {
                                    display: none !important;
                                }
                                &::after {
                                    display: block;
                                    z-index: 3;
                                }
                            }
                        }
                    }
                }
                .topic-people {
                    display: flex;
                    align-items: center;
                    font-size: 12px;
                    line-height:19px;
                    .create-user-logo {
                        height: 18px;
                        width: 18px;
                        border-radius: 50%;
                        cursor: pointer;
                        margin-right: 5px;
                    }
                    .create-user-name {
                        cursor: pointer;
                        margin-right: 2px;
                        &:hover {
                            color: #3a84ff;
                        }
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// topicContainer.vue?4a5805db